import Token from "../jwt/Token.js";

export default function msgErro(response) {
  let data;
  if (Array.isArray(response.response.data)) {
    data = response.response.data[0];
  } else {
    data = response.response.data;
  }

  let status = response.response.status;

  let mensagensDeErro = {
    400: "Requisição inválida. Por favor, verifique os campos dos dados enviados.",
    401: "Não autorizado. É necessário fazer login novamente.",
    403: "Acesso negado. Você não tem permissão para acessar este recurso.",
    404: "Recurso não encontrado. Verifique o URL.",
    409: "Conflito de dados. O recurso já existe ou há um conflito na operação.",
    422: "Erro de validação. Verifique os dados enviados.",
    429: "Muitas requisições. Por favor, tente novamente mais tarde.",
    500: "Erro interno do servidor. Tente novamente mais tarde.",
    502: "Bad Gateway. O servidor recebeu uma resposta inválida.",
    503: "Serviço indisponível. Tente novamente mais tarde.",
    504: "Gateway Timeout. O servidor não respondeu a tempo."
  };

  let mensagemDesenvolvedor = data?.mensagemDesenvolvedor || "";
  let mensagemUsuario = data?.mensagemUsuario || "";

  // Verificar se a mensagem de desenvolvedor contém "NegocioException"
  if (mensagemDesenvolvedor.includes("NegocioException")) {
    let negocio = mensagemDesenvolvedor.replace("br.gov.pa.saude.api.exceptionhandler.NegocioException:", "");
    this.$toast.add({
      severity: "error",
      summary: "Alerta de Erro.",
      detail: negocio,
      life: 6000,
    });
    // Retorna aqui para evitar exibir outro Toast
    return;
  }

  // Verificar e exibir mensagens de erro com base no status HTTP
  if (status >= 400) {
    let mensagemErro = mensagensDeErro[status];
    if (!mensagemErro) {
      mensagemErro = mensagemUsuario || "Erro desconhecido. Contate o administrador.";
    }

    this.$toast.add({
      severity: "error",
      summary: "Alerta de Erro.",
      detail: mensagemErro,
      life: 6000,
    });
  }

  // Verificar se a mensagem de desenvolvedor contém "java.sql.SQLIntegrityConstraintViolationException"
  if (mensagemDesenvolvedor.includes("java.sql.SQLIntegrityConstraintViolationException")) {
    this.$toast.add({
      severity: "error",
      summary: "Alerta de Erro.",
      detail: "Não é possível excluir registros que possuem dados atrelados.",
      life: 6000,
    });
  }

  // Verificar se o token expirou
  if (new Token().isTokenExpired()) {
    let message = "Sessão expirada, efetue login novamente.";
    this.$toast.add({
      severity: "warn",
      summary: "Atenção.",
      detail: message,
      life: 6000,
    });
  }
}



// export default function msgErro(response) {
//   this.mensagemDesenvolvedor = response.response.data[0].mensagemDesenvolvedor;
//   this.mensagemUsuario = response.response.data[0].mensagemUsuario;
//   let data = response.response.data[0];
//   let status = response.response.status;

//   if (status >= 400) {
//     this.$toast.add({
//       severity: "error",
//       summary: "Alerta de Erro.",
//       detail: data.mensagemUsuario,
//       life: 6000,
//     });
//   }

//   let containing = this.mensagemDesenvolvedor.indexOf("NegocioException");
//   let foreignKey = this.mensagemDesenvolvedor.indexOf(
//     "java.sql.SQLIntegrityConstraintViolationException"
//   );
//   if (containing > -1) {
//     let negocio = this.mensagemDesenvolvedor.replace(
//       "br.gov.pa.saude.api.exceptionhandler.NegocioException:",
//       ""
//     );
//     //this.mensagemUsuario = negocio
//     this.$toast.add({
//       severity: "error",
//       summary: "Alerta de Erro.",
//       detail: negocio,
//       life: 6000,
//     });
//   }
//   if (foreignKey > -1) {
//     this.$toast.add({
//       severity: "error",
//       summary: "Alerta de Erro.",
//       detail: "Não é possivel excluir registros cujo estão dados atrelados.",
//       life: 6000,
//     });
//   }

//   if (new Token.checkToken()) {
//     let message = "Secção expirada, efetue login novamente.";
//     this.$toast.add({
//       severity: "warn",
//       summary: "Atenção.",
//       detail: message,
//       life: 6000,
//     });
//   }
// }
